export default __webpack_public_path__ + "static/media/CashbackUpBlack.7a4999c5.svg";